<template>
  <div>
    <div class="detail-html" style="color:rgba(53,53,53,0.80);" v-html="msg"></div>
    <tinymce-editor ref="editor"
      v-model="msg"
      :value = "msg"
      @input="handleInput"
      :disabled="disabled"
      @onClick="onClick">
    </tinymce-editor>
    <button @click="clear">清空内容</button>
  </div>
</template>

<script>
import TinymceEditor from '@/components/tinymce-editor/tinymce-editor'
export default {
  components: {
    TinymceEditor,
  },
  data () {
    return {
      msg: 'Welcome to Use Tinymce Editor',
    }
  },
  created () {
    this.msg = "test"
  },
  methods: {
    // 输入事件
    handleInput(value) {
      this.msg = value
      // console.log(value)
    },
    // 鼠标单击的事件
    onClick (e, editor) {
      // console.log('Element clicked')
      // console.log(e)
      // console.log(editor)
    },
    // 清空内容
    clear () {
      this.$refs.editor.clear()
    },
  }
}
</script>

<style>
  .detail-html {
    max-width: 100%;
    text-align: left;
  }
</style>